import { RouteProps } from "react-router-dom";
import { locale } from "../data/locale";

export function getQuery(
  location: Location | RouteProps["location"] = window.location
) {
  return new URLSearchParams(location.search);
}

export const localeTo = (pathname: string) => {
  if (locale) {
    const [path, hash] = pathname.split("#");
    const result = `${path}?lang=${locale}`;
    return hash ? result + `#${hash}` : result;
  }

  return pathname;
};

export function getShortMonth(date: Date) {
  return date.toLocaleDateString("en-us", { month: "short" });
}
